module.exports = __webpack_public_path__ + "static/media/background.75330c95.jpg";